import useResource from 'app/hooks/useResource';

import {
  getAccounts,
  setAccountParams
} from 'app/actions/accounts';

import {
  createAccount,
  updateAccount,
  destroyAccount
} from 'app/services/accounts';

import {
  accounts as resource
} from 'app/resources';

const useAccounts = props => {
  const {
    onUpdate
  } = props;

  return useResource({
    resource,
    getResource: getAccounts,
    createResource: createAccount,
    updateResource: updateAccount,
    destroyResource: destroyAccount,
    setResourceParams: setAccountParams,
    onUpdate
  });
}

export default useAccounts;
